import * as RdxCheckbox from '@radix-ui/react-checkbox';
import { CheckIcon } from '@radix-ui/react-icons';
import { ClassValue } from 'clsx';
import cn from '../../app/utils/cn';

interface ICheckboxProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: ClassValue;
  'aria-label'?: string;
  id?: string;
}

export default function Checkbox({
  checked,
  onCheckedChange,
  disabled,
  className,
  id,
  'aria-label': ariaLabel,
}: ICheckboxProps) {
  return (
    <RdxCheckbox.Root
      id={id}
      checked={checked}
      onCheckedChange={(value) => onCheckedChange(value === true)}
      disabled={disabled}
      aria-label={ariaLabel}
      className={cn(
        'h-4 w-4 shrink-0 cursor-pointer rounded border transition-colors outline-none',
        'border-grey-400 bg-surface-input dark:border-grey-500',
        'data-[state=unchecked]:hover:border-green-500',
        'data-[state=checked]:border-green-600 data-[state=checked]:bg-green-600',
        'focus-visible:ring-2 focus-visible:ring-green-500/50',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
    >
      <RdxCheckbox.Indicator className="text-text-on-brand flex items-center justify-center">
        <CheckIcon className="h-3 w-3" />
      </RdxCheckbox.Indicator>
    </RdxCheckbox.Root>
  );
}
